import { Typography } from "@mui/material";
import React from "react";

const SimpleText = ({ style, text }) => {
  return (
    <Typography sx={style}>
      <div
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      ></div>
    </Typography>
  );
};

export default SimpleText;
